import React from 'react';
import styled, { css } from 'styled-components';

import { breakpoints } from 'theme';

import { StickyHeaderLinksItem } from './StickyHeaderLinksItem';

export const StickyHeaderLinksList = styled(
  ({
    className,
    links,
    isSticky,
  }: {
    className?: string;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    links: Array<Record<string, any>>;
    isSticky?: boolean;
  }) => (
    <nav className={className}>
      <ul>
        {links.map((link, index) => (
          <StickyHeaderLinksItem
            link={link}
            isSticky={isSticky}
            total={links.length} // eslint-disable-next-line react/no-array-index-key
            key={`${index}-${link.url}`}
          />
        ))}
      </ul>
    </nav>
  )
)<{ hasButton?: boolean }>`
  width: 100%;

  ul {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  @media (min-width: ${breakpoints[2]}) {
    ul {
      flex-direction: row;
    }
  }

  ${(props) =>
    props.isSticky &&
    css`
      display: none;

      @media (min-width: ${breakpoints[2]}) {
        display: flex;
        justify-content: center;
        padding-right: ${props.hasButton ? 0 : 160}px;
      }
    `};
`;
